<ng-container [ngSwitch]="model">
  <ng-container *ngSwitchCase="StudyLevelEnum.Any" i18n>Indifférent</ng-container>
  <ng-container *ngSwitchCase="StudyLevelEnum.BacProBepCap" i18n>Bac&nbsp;Pro, BEP, CAP</ng-container>
  <ng-container *ngSwitchCase="StudyLevelEnum.Bac" i18n>Bac</ng-container>
  <ng-container *ngSwitchCase="StudyLevelEnum.BtsDutBac2" i18n>BTS, DUT, BAC&nbsp;+2</ng-container>
  <ng-container *ngSwitchCase="StudyLevelEnum.LicenseM1Bac34" i18n>Licence, M1, Bac&nbsp;+3/4</ng-container>
  <ng-container *ngSwitchCase="StudyLevelEnum.MasterIngenieurBac5" i18n
    >Master, Titre&nbsp;d’ingénieur, Bac&nbsp;+5</ng-container
  >
  <ng-container *ngSwitchCase="StudyLevelEnum.DoctoratBac8" i18n>Doctorat, Bac&nbsp;+8</ng-container>

  <ng-container *ngSwitchDefault>{{ model }}</ng-container>
</ng-container>
